import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainNavbar = _resolveComponent("MainNavbar")!
  const _component_MainBanner = _resolveComponent("MainBanner")!
  const _component_AwardWinning = _resolveComponent("AwardWinning")!
  const _component_WhatWeDo = _resolveComponent("WhatWeDo")!
  const _component_FunFacts = _resolveComponent("FunFacts")!
  const _component_CapabilitiesContent = _resolveComponent("CapabilitiesContent")!
  const _component_OurProcess = _resolveComponent("OurProcess")!
  const _component_AwardWinningAgency = _resolveComponent("AwardWinningAgency")!
  const _component_SuccessStories = _resolveComponent("SuccessStories")!
  const _component_IncreaseYourBrands = _resolveComponent("IncreaseYourBrands")!
  const _component_TestimonialsContent = _resolveComponent("TestimonialsContent")!
  const _component_TransformYourBrand = _resolveComponent("TransformYourBrand")!
  const _component_OurBlog = _resolveComponent("OurBlog")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainNavbar, {
      class: "bg-transparent fixed-top",
      mwClass: "",
      className: "m-auto"
    }),
    _createVNode(_component_MainBanner),
    _createVNode(_component_AwardWinning),
    _createVNode(_component_WhatWeDo),
    _createVNode(_component_FunFacts),
    _createVNode(_component_CapabilitiesContent),
    _createVNode(_component_OurProcess),
    _createVNode(_component_AwardWinningAgency),
    _createVNode(_component_SuccessStories),
    _createVNode(_component_IncreaseYourBrands, { className: "border-style pb-100" }),
    _createVNode(_component_TestimonialsContent),
    _createVNode(_component_TransformYourBrand),
    _createVNode(_component_OurBlog),
    _createVNode(_component_MainFooter)
  ], 64))
}